import React from 'react';
import {Button, Divider, Icon, Input, message, Modal, Select, Spin, Table, Tag} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";
import ReactJson from "react-json-view";

const { TextArea } = Input;
const { Option } = Select;

export default class PurchaseOrderList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            showOrderInfoDialog: false,
            showResourcesDialog: false,
            showMessageDialog: false,
            showRechargeModal: false,
            showAddResourceModal: false,
            showConfirmModal: false,
            confirmLoading: false,
            planList: [],
            paymentStatusList: [],
            paymentWayList: [],
            selectedOrder: {},
            query_params: {},
            form_refund_params: {},
            form_recharge_params: {},
            form_resource_params: {},
            iamOrderId: '',
            iamOrderType: 'Order',
            iamOrderDetail: {}
        }
    }

    componentDidMount() {
        this.loadListData();
        this.loadPurchasePlanList();
        this.loadPaymentWayList();
        this.loadPaymentStatusList();
    }

    setStateParams(params, name, value) {
        params[name] = value;
        this.setState(params);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    handleInputFocus(event) {
        const target = event.target;
        if (target.type === 'text') {
            this.setState({showMessageDialog: false});
        }
    }

    loadListData(changedParams) {
        if (!changedParams) {
            changedParams = {
                currentPage: 1,
                pageSize: 10
            };
        }
        let params = this.state.query_params;
        params.currentPage = changedParams.currentPage;
        params.pageSize = changedParams.pageSize;

        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/query-order-list', params)
            .then(response => {
                console.debug("query-order-list response -> " + JSON.stringify(response));
                this.setState({loading: false});
                if (response.code === 200) {
                    this.setState({
                        dataList: response.rows,
                        total: response.total,
                        currentPage: changedParams.currentPage,
                        pageSize: changedParams.pageSize
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    loadUserResources(userId) {
        this.setState({showResourcesDialog: true});
        new WebServerRestClient().GET('/admin/user/resources/' + userId)
            .then(response => {
                console.debug("user/resources response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({resources: response.data, loading: false})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadPurchasePlanList() {
        new WebServerRestClient().GET('/open/purchase-plans')
            .then(response => {
                console.log("load purchase-plan response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({planList: response.data})
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadPaymentWayList() {
        new WebServerRestClient().GET('/admin/dict/payment-way')
            .then(response => {
                console.log("load payment-way response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({paymentWayList: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadPaymentStatusList() {
        new WebServerRestClient().GET('/admin/dict/payment-status')
            .then(response => {
                console.log("load payment-status response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({paymentStatusList: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    retrieveIapOrder() {
        const requestURL = this.state.iamOrderType === 'Order' ?
            `/admin/app-store-orders/${this.state.iamOrderId}` : `/admin/app-store-transactions/${this.state.iamOrderId}`
        this.setState({loading: true});
        new WebServerRestClient().GET(requestURL)
            .then(response => {
                if (response.code === 200) {
                    this.setState({
                        showIamOrderModal: true,
                        iamOrderDetail: response.data
                    })
                } else {
                    message.error(response['msg']);
                }
                this.setState({loading: false});
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
            this.setState({loading: false});
        });
    }

    render() {
        return (
            <div className="container">
                <div className="toolbar">
                    <Input placeholder="Email"
                           className="search_input"
                           onChange={(event) => this.setStateParams(this.state.query_params, 'email', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Input placeholder="Transaction ID"
                           className="search_input"
                           onChange={(event) => this.setStateParams(this.state.query_params, 'txnNo', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="Payment Status"
                            allowClear={true}
                            onChange={(value) => this.setStateParams(this.state.query_params, 'paymentStatus', value)}>
                        {this.state.paymentStatusList.map(item => (
                            <Option key={item.value}>{item.key}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            allowClear={true}
                            placeholder="Payment Way"
                            onChange={(value) => this.setStateParams(this.state.query_params, 'paymentWay', value)}>
                        {this.state.paymentWayList.map(item => (
                            <Option key={item.value}>{item.key}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Button type="primary"  icon="search" className="search_btn" loading={this.state.doing}
                            onClick={this.loadListData.bind(this)}>
                        Search
                    </Button>
                    <Divider type="vertical"/>
                    <div className="button_group">
                        <Button type="link" icon="pay-circle" size={"small"}
                                onClick={this.startRecharge.bind(this)}>Recharge</Button>
                        <Button type="link" icon="file-add" size={"small"}
                                onClick={this.startAddResource.bind(this)}>Resource</Button>
                    </div>
                    <Input placeholder="IAP Order ID"
                           className="search_input"
                           onChange={(event) => this.setState({iamOrderId: event.target.value})}/>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            value={this.state.iamOrderType}
                            placeholder="Order type"
                            allowClear={true}
                            onChange={(value) => this.setState({iamOrderType: value})}>
                        <Option key="Order">Order</Option>
                        <Option key="Transaction">Transaction</Option>
                    </Select>
                    <Divider type="vertical"/>
                    <Button type="primary"  icon="search" className="search_btn" loading={this.state.doing}
                            onClick={this.retrieveIapOrder.bind(this)}>
                        Retrieve
                    </Button>
                </div>

                <Table loading={this.state.loading}
                       rowKey={'orderId'}
                       columns={[
                           {title: 'Email', dataIndex: 'email', align: 'center'},
                           {title: 'Product', dataIndex: 'purchasePlanName', align: 'center'},
                           {title: 'Amount($)', dataIndex: 'amount', align: 'center' },
                           {title: 'PaymentWay', dataIndex: 'paymentWayText', align: 'center' },
                           {title: 'Status', dataIndex: 'paymentStatusText', align: 'center' },
                           {title: 'PaymentTime', dataIndex: 'paymentTime', align: 'center'},
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               render: (text, record) => (
                                   <span>
                                       <a onClick={() => this.showInfoModal(record)}>View</a>
                                       {
                                           record.paymentStatus == 2 ?
                                           <span>
                                               <Divider type="vertical"/>
                                               <a onClick={() => this.showRefundModal(record.orderId)}>Refund</a>
                                           </span>
                                           :
                                           null
                                       }
                                       <Divider type="vertical"/>
                                       <a onClick={() => this.loadUserResources(record.userId)}>Resources</a>
                                  </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={{
                           current: this.state.currentPage,
                           pageSize: this.state.pageSize,
                           total: this.state.total,
                           onChange: (currentPage, pageSize) => {
                               this.setState({loading: true});
                               this.loadListData({currentPage, pageSize});
                           },
                           showTotal: ((total) => {
                               return `total of ${total} records`;
                           }),
                           className: "pagination"
                       }}/>

                <Modal
                    title="Order Info"
                    footer={null}
                    visible={this.state.showOrderInfoDialog}
                    onCancel={() => this.setState({showOrderInfoDialog: false})}>
                        <p><Tag color="cyan">Order ID:</Tag> {this.state.selectedOrder.orderId}</p>
                        <p><Tag color="cyan">User ID:</Tag> {this.state.selectedOrder.userId}</p>
                        <p><Tag color="cyan">Email:</Tag> {this.state.selectedOrder.email}</p>
                        <p><Tag color="cyan">Plan Name:</Tag> {this.state.selectedOrder.purchasePlanName}</p>
                        <p><Tag color="cyan">Amount:</Tag> ${this.state.selectedOrder.amount}</p>
                        <p><Tag color="cyan">Payment Status:</Tag> {this.state.selectedOrder.paymentStatusText}</p>
                        <p><Tag color="cyan">Payment Way:</Tag> {this.state.selectedOrder.paymentWayText}</p>
                        <p><Tag color="cyan">Payment Source:</Tag> {this.state.selectedOrder.paymentSource}</p>
                        <p><Tag color="cyan">Payment Time:</Tag> {this.state.selectedOrder.paymentTime}</p>
                        <p><Tag color="cyan">Created Time:</Tag> {this.state.selectedOrder.createdTime}</p>
                        <p><Tag color="cyan">Txn No:</Tag> {this.state.selectedOrder.txnNo}</p>
                        <p><Tag color="cyan">Remarks:</Tag> {this.state.selectedOrder.errorMessage}</p>
                </Modal>

                <Modal
                    title="User Resources"
                    width={800}
                    footer={null}
                    visible={this.state.showResourcesDialog}
                    onCancel={() => this.setState({showResourcesDialog: false})}>
                    <Table loading={this.state.loading}
                           rowKey={'id'}
                           dataSource={this.state.resources}
                           columns={[
                               {title: 'Days', dataIndex: 'availableDays', align: 'center'},
                               {title: 'ExpireTime', dataIndex: 'expireTime', align: 'center'},
                               {title: 'createdTime', dataIndex: 'createdTime', align: 'center'},
                               {title: 'Remarks', dataIndex: 'remarks', align: 'left'}
                           ]}/>
                </Modal>

                <Modal
                    title="Refund Order"
                    visible={this.state.showConfirmModal}
                    onCancel={() => this.setState({showConfirmModal: false})}
                    onOk={() => this.refundOrder()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                    <TextArea name={'remarks'} rows={2} placeholder={'Refund reason'}
                              onChange={(event) => this.setStateParams(this.state.form_refund_params, 'remarks', event.target.value)}/>
                </Modal>

                <Modal
                    keyboard={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    title="Recharge"
                    visible={this.state.showRechargeModal}
                    onCancel={() => this.setState({showRechargeModal: false})}
                    onOk={() => this.rechargeOrder()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                        <Input placeholder={'Email Account'}
                               className="mt_10 width_100"
                               value={this.state.form_recharge_params.email}
                               onChange={(event) => this.setStateParams(this.state.form_recharge_params, 'email', event.target.value)}/>
                        <Select className="mt_10 width_100"
                                placeholder="Purchase plan"
                                value={this.state.form_recharge_params.purchasePlanId}
                                onChange={(value) => this.setStateParams(this.state.form_recharge_params, 'purchasePlanId', value)}>
                            {this.state.planList.map(item =>(
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                        <Select className="mt_10 width_100"
                                addonBefore={"Payment Way"}
                                placeholder="Payment way"
                                value={this.state.form_recharge_params.paymentWay}
                                onChange={(value) => this.setStateParams(this.state.form_recharge_params, 'paymentWay', value)}>
                            {this.state.paymentWayList.map(item => (
                                <Option key={item.value}>{item.key}</Option>
                            ))}
                        </Select>
                        <Input placeholder={'Payment source'}
                               className="mt_10 width_100"
                               value={this.state.form_recharge_params.sourceId}
                               onChange={(event) => this.setStateParams(this.state.form_recharge_params, 'sourceId', event.target.value)}/>
                        <Input placeholder={'Transaction ID'}
                               className="mt_10 width_100"
                               value={this.state.form_recharge_params.chargeId}
                               onChange={(event) => this.setStateParams(this.state.form_recharge_params, 'chargeId', event.target.value)}/>
                        <Input placeholder={'Remarks'}
                               className="mt_10 width_100"
                               value={this.state.form_recharge_params.remarks}
                               onChange={(event) => this.setStateParams(this.state.form_recharge_params, 'remarks', event.target.value)}/>
                </Modal>

                <Modal
                    title="Manual Add Resource"
                    visible={this.state.showAddResourceModal}
                    onCancel={() => this.setState({showAddResourceModal: false})}
                    onOk={() => this.manualAddResource()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                        <Input placeholder={'userId'}
                               className="mt_10 width_100"
                               value={this.state.form_resource_params.userId}
                               onChange={(event) => this.setStateParams(this.state.form_resource_params, 'userId', event.target.value)}/>
                        <Input placeholder={'days'}
                               className="mt_10 width_100"
                               value={this.state.form_resource_params.availableDays}
                               onChange={(event) => this.setStateParams(this.state.form_resource_params, 'availableDays', event.target.value)}/>
                        <Input placeholder={'remarks'}
                               className="mt_10 width_100"
                               value={this.state.form_resource_params.remarks}
                               onChange={(event) => this.setStateParams(this.state.form_resource_params, 'remarks', event.target.value)}/>
                        <Select className="mt_10 width_100"
                                placeholder="select source type"
                                value={this.state.form_resource_params.source}
                                onChange={(value) => this.setStateParams(this.state.form_resource_params, 'source', value)}>
                                <Option key="6">free-extension</Option>
                                <Option key="8">deducted</Option>
                        </Select>
                </Modal>

                <Modal
                    title="IAP Order Query"
                    visible={this.state.showIamOrderModal}
                    onCancel={() => this.setState({showIamOrderModal: false})}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                    <ReactJson src={this.state.iamOrderDetail}
                               groupArraysAfterLength={1000}
                               name={false} displayDataTypes={false}  theme="monokai"/>
                </Modal>
            </div>
        )
    }

    startRecharge(){
        let form_params = this.state.form_recharge_params;

        // reset value
        delete form_params.email;
        delete form_params.purchasePlanId;
        delete form_params.paymentWay;
        delete form_params.chargeId;
        delete form_params.remarks;
        this.setState({showRechargeModal: true});
    }

    startAddResource(){
        let form_params = this.state.form_resource_params;

        // reset value
        delete form_params.userId;
        delete form_params.availableDays;
        delete form_params.remarks;
        delete form_params.source;
        this.setState({showAddResourceModal: true});
    }

    showInfoModal(row){
        this.setState({
            showOrderInfoDialog: true,
            selectedOrder: row
        })
    };

    showRefundModal(orderId) {
        this.setState({
            showConfirmModal: true,
            form_refund_params: {
                orderId: orderId,
                remarks: ''
            }
        });
    };

    refundOrder () {
        this.setState({confirmLoading: true});
        new WebServerRestClient().POST('/admin/refund-order', this.state.form_refund_params)
            .then(response => {
                console.log("refund-order response -> " + JSON.stringify(response));
                this.setState({showConfirmModal: false, confirmLoading: false});
                if (response.code === 200) {
                    this.loadListData();
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

    rechargeOrder () {
        let form_params = this.state.form_recharge_params;
        if(!form_params.email || form_params.email.trim().length === 0){
            message.warn('Parameters[email] is empty!');
            return false;
        }
        if(!form_params.purchasePlanId || form_params.purchasePlanId === 0){
            message.warn('Parameters[days] is empty!');
            return false;
        }
        if(!form_params.paymentWay || form_params.paymentWay === 0){
            message.warn('Parameters[paymentWay] is empty!');
            return false;
        }
        if(!form_params.sourceId || form_params.sourceId.trim().length === 0){
            message.warn('Parameters[sourceId] is empty!');
            return false;
        }
        if(!form_params.chargeId || form_params.chargeId.trim().length === 0){
            message.warn('Parameters[chargeId] is empty!');
            return false;
        }

        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/create-manual-order', form_params)
            .then(response => {
                CommonUtils.log("create-manual-order response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showRechargeModal: false});
                    this.loadListData();
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

    manualAddResource () {
        let form_params = this.state.form_resource_params;
        if(!form_params.userId || form_params.userId.trim().length === 0){
            message.warn('Parameters[userId] is empty!');
            return false;
        }
        if(!form_params.availableDays || form_params.availableDays <= 0){
            message.warn('Parameters[days] must be a positive number!');
            return false;
        }
        if(!form_params.availableDays || form_params.availableDays === 0){
            message.warn('Parameters[source] is empty!');
            return false;
        }

        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/manual-add-resource', form_params)
            .then(response => {
                CommonUtils.log("manual-add-resource response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showAddResourceModal: false});
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };
}
